import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Button, Container, Row, Col } from 'reactstrap';
import { Form, Field, ErrorMessage, withFormik } from 'formik';
import * as yup from 'yup';

import axios from 'axios';
import { getSimplAdminUrl } from '../utils/env';

import * as actions from '../store/actions/wamp';

class FormikForm extends React.PureComponent {
  render() {
    // console.log('CreateRunForm: props:', this.props);
    return (
      <Container>
        <Row>
          <Col>
            <Form layout="inline">
              <div className="form-group">
                <Field
                  type="text"
                  name="name"
                  placeholder="Run name"
                  className="form-control"
                />
                <ErrorMessage name="name" />
              </div>
              <Button
                className="btn btn-labeled btn-bay-blue float-right"
                type="submit"
              >
                <span className="btn-label">
                  <FontAwesomeIcon icon="play" />
                </span>{' '}
                Start Task
              </Button>
            </Form>
          </Col>
        </Row>
        <Row>
          <Col>
            <br />
            <span>
              <strong>NOTE</strong> tasks may take a few minutes to complete.
            </span>
          </Col>
        </Row>
      </Container>
    );
  }
}

const CreateRunValidation = yup.object().shape({
  name: yup.string().required('Please enter a run name.'),
});

const CreateRunForm = withFormik({
  mapPropsToValues: props => {
    return {
      name: '',
    };
  },
  validationSchema: CreateRunValidation,
  validateOnChange: true,
  validateOnBlur: true,
  handleSubmit: (
    values,
    { props: { loading, error, createRun, simplAdminToken } }
  ) => {
    // console.log('values:', values);
    const name = values.name;
    // console.log('handleSubmit name:', name);
    createRun(name, simplAdminToken);
  },
})(FormikForm);

// form container

const mapStateToProps = (state, ownProps) => {
  // console.log('ownProps:', ownProps);
  const { simplAdminToken } = state.auth;
  return {
    simplAdminToken,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    createRun: (name, simplAdminToken) => {
      const { gameSlug, afterSubmit } = ownProps;
      console.log('createRun: gameSlug:', gameSlug);
      dispatch(actions.createRun(gameSlug, name))
        .then(result => {
          const { payload } = result;
          // console.log('payload:', payload);
          const { celery_task_id, error } = payload;
          console.log(
            'createRun celery_task_id:',
            celery_task_id,
            ', error:',
            error
          );
          if (typeof error === 'undefined') {
            // add task to database
            axios
              .post(
                `${getSimplAdminUrl()}/api/tasks/`,
                {
                  game_slug: gameSlug,
                  task_name: 'create_run',
                  celery_task_id: celery_task_id,
                },
                { headers: { Authorization: simplAdminToken } }
              )
              .then(res => {
                console.log(res);
                afterSubmit();
              })
              .catch(err => {
                console.log(err);
              });
          }
        })
        .catch(error => {
          console.log('createRun error:', error);
        });
    },
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CreateRunForm)
);
